import { useContext, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios'
import GlobalContext from './GlobalContext';


function DeletarUsuario(props) {
    const [show, setShow] = useState(false);

    const { globalData, setGlobalData } = useContext(GlobalContext);


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const deleteUser = () => {
        axios.delete(`${globalData.apiHost}/deleteuser/${props.uid}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': process.env.REACT_APP_BACKEND_SECRET
                }
            })
            .then((response) => {
                console.log(response)
                props.handleShowToast('Usuário Excluído', `Usuário ${props.email} excluído com sucesso`);
                props.refreshListaUsuarios();
                handleClose()
            })
    }

    return (
        <>
            <Button variant="danger" size="sm" className="ms-2" title='Deletar' onClick={handleShow}>
                <i className="bi bi-trash"></i>
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Deletar Usuário</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Você está prestes a deletar o usuário <b>{props.email}</b>.<br />
                    Esta ação é permanente e irreversível.<br />
                    Deseja continuar?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={deleteUser}>
                        Sim
                    </Button>
                    <Button variant="outline-danger" onClick={handleClose}>
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default DeletarUsuario